/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ResourceDto
 */
export interface ResourceDto {
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'type': ResourceDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'createdAt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ResourceDtoTypeEnum {
    SECTION = 'SECTION',
    GROUP = 'GROUP',
    EXTERNAL_MEMBER_AREA = 'EXTERNAL_MEMBER_AREA'
}


